import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { OfficeDto } from '../lib/types';

export function useOffices() {
  return useQuery({
    queryKey: ['offices'],
    queryFn: () => apiClient.get<OfficeDto[]>('/api/offices'),
  });
}
